/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { ApiKeysApi } from './services/ApiKeysApi';
import { CategoriesSettingsApi } from './services/CategoriesSettingsApi';
import { CategoryPresetsApi } from './services/CategoryPresetsApi';
import { ChangelogsApi } from './services/ChangelogsApi';
import { GameCategorySettingsApi } from './services/GameCategorySettingsApi';
import { GamesApi } from './services/GamesApi';
import { GamesCategoriesApi } from './services/GamesCategoriesApi';
import { GamesSettingsApi } from './services/GamesSettingsApi';
import { HealthcheckApi } from './services/HealthcheckApi';
import { LanguagesApi } from './services/LanguagesApi';
import { ProviderConfigsApi } from './services/ProviderConfigsApi';
import { UsersApi } from './services/UsersApi';
import { DisabledOwnersApi } from './services/DisabledOwnersApi';
import { CategoryGamesApi } from '@/api/generated-client/services/CategoryGamesApi';
import { CurrenciesApi } from '@/api/generated-client/services/CurrenciesApi';
import { ProvidersFeesApi } from '@/api';
import { AggregatorsApi } from '@/api/generated-client/services/AggregatorsApi';
import { ProvidersDiscountApi } from '@/api/generated-client/services/ProvidersDiscountsApi';
import { CommentsApi } from '@/api/generated-client/services/CommentsApi';
import { ComplaintsApi } from '@/api/generated-client/services/ComplaintsApi';
import { FrequenciesApi } from '@/api/generated-client/services/FrequenciesApi';
import { StopPhrasesApi } from '@/api/generated-client/services/StopPhrasesApi';
import { UserBlockApi } from '@/api/generated-client/services/UserBlockApi';
import { CollectionsApi } from '@/api/generated-client/services/CollectionsApi';
import { TenantApi } from '@/api/generated-client/services/TenantApi';
import { GamesOfWeekApi } from '@/api/generated-client/services/GamesOfWeekApi';
import { PresetsApi } from "@/api/generated-client/services/PresetsApi";
import { GamesCatalogApi } from "@/api/generated-client/services/GamesCatalogApi";
import { TagsApi } from "@/api/generated-client/services/TagsApi";
import { GameTagsApi } from '@/api/generated-client/services/GameTagsApi';
import { ProvidersEnabledRulesApi } from '@/api/generated-client/services/ProvidersEnabledRulesApi';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class ApiClient {
  public readonly apiKeys: ApiKeysApi;
  public readonly categoriesSettings: CategoriesSettingsApi;
  public readonly categoryPresets: CategoryPresetsApi;
  public readonly changelogs: ChangelogsApi;
  public readonly gameCategorySettings: GameCategorySettingsApi;
  public readonly games: GamesApi;
  public readonly gamesCategories: GamesCategoriesApi;
  public readonly gamesSettings: GamesSettingsApi;
  public readonly healthcheck: HealthcheckApi;
  public readonly languages: LanguagesApi;
  public readonly providerConfigs: ProviderConfigsApi;
  public readonly users: UsersApi;
  public readonly disabledOwnersApi: DisabledOwnersApi;
  public readonly categoryGamesApi: CategoryGamesApi;
  public readonly currenciesApi: CurrenciesApi;
  public readonly providersFeesApi: ProvidersFeesApi;
  public readonly aggregatorsApi: AggregatorsApi;
  public readonly providersDiscountApi: ProvidersDiscountApi;
  public readonly commentsApi: CommentsApi;
  public readonly complaintsApi: ComplaintsApi;
  public readonly frequenciesApi: FrequenciesApi;
  public readonly stopPhrasesApi: StopPhrasesApi;
  public readonly userBlockApi: UserBlockApi;
  public readonly collectionsApi: CollectionsApi;
  public readonly gamesOfWeekApi: GamesOfWeekApi;
  public readonly request: BaseHttpRequest;
  public readonly tenantApi: TenantApi;
  public readonly presetsApi: PresetsApi;
  public readonly gamesCatalogApi: GamesCatalogApi;
  public readonly providersEnabledRulesApi: ProvidersEnabledRulesApi;
  public readonly tagsApi: TagsApi;
  public readonly gameTagsApi: GameTagsApi;

  constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? '',
      VERSION: config?.VERSION ?? 'local_version',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });
    this.apiKeys = new ApiKeysApi(this.request);
    this.categoriesSettings = new CategoriesSettingsApi(this.request);
    this.categoryPresets = new CategoryPresetsApi(this.request);
    this.changelogs = new ChangelogsApi(this.request);
    this.gameCategorySettings = new GameCategorySettingsApi(this.request);
    this.games = new GamesApi(this.request);
    this.gamesCategories = new GamesCategoriesApi(this.request);
    this.gamesSettings = new GamesSettingsApi(this.request);
    this.healthcheck = new HealthcheckApi(this.request);
    this.languages = new LanguagesApi(this.request);
    this.providerConfigs = new ProviderConfigsApi(this.request);
    this.users = new UsersApi(this.request);
    this.disabledOwnersApi = new DisabledOwnersApi(this.request);
    this.categoryGamesApi = new CategoryGamesApi(this.request);
    this.currenciesApi = new CurrenciesApi(this.request);
    this.providersFeesApi = new ProvidersFeesApi(this.request);
    this.aggregatorsApi = new AggregatorsApi(this.request);
    this.providersDiscountApi = new ProvidersDiscountApi(this.request);
    this.commentsApi = new CommentsApi(this.request);
    this.complaintsApi = new ComplaintsApi(this.request);
    this.frequenciesApi = new FrequenciesApi(this.request);
    this.stopPhrasesApi = new StopPhrasesApi(this.request);
    this.userBlockApi = new UserBlockApi(this.request);
    this.collectionsApi = new CollectionsApi(this.request);
    this.gamesOfWeekApi = new GamesOfWeekApi(this.request);
    this.tenantApi = new TenantApi(this.request);
    this.presetsApi = new PresetsApi(this.request);
    this.gamesCatalogApi = new GamesCatalogApi(this.request);
    this.providersEnabledRulesApi = new ProvidersEnabledRulesApi(this.request);
    this.tagsApi = new TagsApi(this.request);
    this.gameTagsApi = new GameTagsApi(this.request);
  }
}
